import RequestError from "./RequestError";
export function getRequestData() {
    return window['requestData'];
}
class Auth {
    constructor(params) {
        this.auth_endpoint = params.auth_endpoint;
    }
    async login(email, password) {
        let body = Auth.formData();
        body.append('email', email);
        body.append('password', password);
        return this.request('users/login', body);
    }
    async signup(email, password) {
        let body = Auth.formData();
        body.append('email', email);
        body.append('password', password);
        return this.request('users/signup', body);
    }
    async passwordReset(email) {
        let body = Auth.formData();
        body.append('email', email);
        return this.request('users/reset-password', body);
    }
    async savePassword(password, token) {
        let body = Auth.formData();
        body.append('password', password);
        body.append('resetToken', token);
        return this.request('users/save-password', body);
    }
    static formData() {
        return new FormData();
    }
    static formBasicData() {
        return this.formData();
    }
    request(endpoint, body) {
        return fetch(this.auth_endpoint + endpoint, {
            method: 'POST',
            credentials: 'include',
            body: body
        })
            .then(response => {
            return response.json();
        })
            .then(response => {
            if (response.status !== 'ok') {
                throw new RequestError(response.message, response);
            }
            return response;
        });
    }
}
export default Auth;
